"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var appear = exports.appear = function appear() {
  return { opacity: 0 };
};

var appeared = exports.appeared = function appeared() {
  return { opacity: 1 };
};

var enter = exports.enter = appear;

var entered = exports.entered = appeared;

var leaved = exports.leaved = appear;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(appear, "appear", "src/animations/transitions/fade.js");

  __REACT_HOT_LOADER__.register(appeared, "appeared", "src/animations/transitions/fade.js");

  __REACT_HOT_LOADER__.register(enter, "enter", "src/animations/transitions/fade.js");

  __REACT_HOT_LOADER__.register(entered, "entered", "src/animations/transitions/fade.js");

  __REACT_HOT_LOADER__.register(leaved, "leaved", "src/animations/transitions/fade.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/react-stack-grid/lib/animations/transitions/fade.js
// module id = 538
// module chunks = 35783957827783